// AnimatedNumber.tsx
import { useEffect, useState } from "react";

interface Props {
  value: number;
  duration?: number; // ms
}

export default function AnimatedNumber({ value, duration = 1200 }: Props) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = value;

    const frameRate = 1000 / 60; // 60fps
    const totalFrames = Math.round(duration / frameRate);
    let frame = 0;

    // Smooth ease-out function
    const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

    const counter = setInterval(() => {
      frame++;

      const progress = easeOutCubic(frame / totalFrames);
      const current = Math.round(start + (end - start) * progress);

      setDisplay(current);

      if (frame === totalFrames) clearInterval(counter);
    }, frameRate);

    return () => clearInterval(counter);
  }, [value, duration]);

  return <>{display.toLocaleString()}</>;
}
